<script lang="ts" setup>
import {useQuizStore} from '@/stores/quizStore';
import {computed} from 'vue';

const {step, steps, goToPreviousStep, vehicles, goToStepPath, selectedVehicles} = useQuizStore()

const showBack = computed(() => step.value > 0 && step.value < 6)

const percentProgress = computed(() => {
  return Math.trunc((step.value * 100) / (steps.value - 1))
})

const showProgress = computed(() => percentProgress.value > 0 && percentProgress.value < 100)

function handleBack() {
  const shouldSkipVehicleSelectionStep = !vehicles.value.length ||
    (vehicles.value.length === 1 && vehicles.value[0].selected)

  if (step.value === 4 && vehicles.value.length && !selectedVehicles.length) {
    goToStepPath(3)
    return
  }

  if (step.value === 4 && shouldSkipVehicleSelectionStep) {
    goToStepPath(2)
    return
  }
  goToPreviousStep()
}
</script>

<template>
  <div v-if="showProgress" :class="{ 'justify-between': showBack, 'justify-end': !showBack }"
       class="flex items-center mb-5">
    <button v-if="showBack" @click="handleBack"
            class="cursor-pointer text-xs flex items-center space-x-1">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3" width="200" height="200" fill="none"
           stroke="currentColor" stroke-width="2" aria-hidden="true" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" d="m10 19-7-7m0 0 7-7m-7 7h18"/>
      </svg>
      <span class="font-medium">Back</span>
    </button>
    <span class="text-xs font-medium">{{ percentProgress }}%</span>
  </div>

  <div v-if="showProgress" class="w-full bg-gray-200 rounded-full h-2.5 relative mb-4">
    <div class="bg-green-600 h-2.5 rounded-full" :style="{ width: percentProgress + '%' }"></div>
    <div v-if="percentProgress > 0"
         class="bg-green-600 text-white rounded-full absolute p-2 top-1/2 -translate-x-1/2 -translate-y-1/2"
         :style="{ left: percentProgress + '%' }">
      <img alt="car side" src="@/assets/icons/car-side.svg" class="w-6"/>
    </div>
  </div>
</template>
